import { Translatable } from '@fmnts/api/shared';
import { Adapter } from '@fmnts/core';
import { IFieldCondition } from '../api-model/condition';
import { CampaignField, CampaignFieldAdapter } from './campaign-field';
import { FormFieldset } from './form-fieldset';

interface ICampaignFieldset {
  key: string;
  fields: CampaignField[];
  label: Translatable<string>;
  condition?: IFieldCondition;
}
export class CampaignFieldset extends FormFieldset {
  override fields: CampaignField[];

  constructor(dto: Readonly<ICampaignFieldset>) {
    super(dto);
    this.fields = dto.fields;
  }
}

export class CampaignFieldsetAdapter implements Adapter<CampaignFieldset> {
  constructor(private fieldAdapter = new CampaignFieldAdapter()) {}

  adapt(item: Record<string, any>): CampaignFieldset {
    return new CampaignFieldset({
      key: item['key'],
      fields: (item['fields'] || []).map((field: Record<string, any>) =>
        this.fieldAdapter.adapt(field),
      ),
      label: item['label'],
      condition: item['condition'],
    });
  }
}
